import { NgModule } from '@angular/core'
import { VerticalScrollListenerDirective } from './vertical-scroll-listener.directive'

@NgModule({
  declarations: [VerticalScrollListenerDirective],
  exports: [VerticalScrollListenerDirective]
})
export class VerticalScrollListenerModule {}
